import React from 'react'
import Navbar from './components/Navbar'

const Header: React.FC = () => {
    return <Navbar />
}

export default Header
